/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_DisclaimerInputs */

const en_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information only — not legal or medical advice.`)
};

const th_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ช่วยอัตโนมัติ ให้ข้อมูลเท่านั้น ไม่ใช่คำแนะนำทางกฎหมายหรือทางการแพทย์`)
};

const ja_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information only — not legal or medical advice.`)
};

const fr_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information only — not legal or medical advice.`)
};

const es_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information only — not legal or medical advice.`)
};

const ru_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information only — not legal or medical advice.`)
};

const zh_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information only — not legal or medical advice.`)
};

const vi_chat_disclaimer = /** @type {(inputs: Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ mang tính thông tin — không phải tư vấn pháp lý hay y tế.`)
};

/**
* | output |
* | --- |
* | "Information only — not legal or medical advice." |
*
* @param {Chat_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_disclaimer = /** @type {((inputs?: Chat_DisclaimerInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_DisclaimerInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_disclaimer(inputs)
	if (locale === "ja") return ja_chat_disclaimer(inputs)
	if (locale === "fr") return fr_chat_disclaimer(inputs)
	if (locale === "es") return es_chat_disclaimer(inputs)
	if (locale === "ru") return ru_chat_disclaimer(inputs)
	if (locale === "zh") return zh_chat_disclaimer(inputs)
	if (locale === "vi") return vi_chat_disclaimer(inputs)
	return en_chat_disclaimer(inputs)
});